import {type EventEmitter} from 'node:events';
import {type Hasi, type HasiStatus} from '@qep/common';
import {type CONNECTIVITY_STATUSES, type HEALTH_ENDPOINTS} from '../connectivity';

type ConnectivityMethod<T, U> = (parameters: T) => U;
type ConnectivityMethodCallback<T, V, U> = (arg1: T, arg2: V) => U;

export type ConnectivityType = {
  connectivityEmitter: EventEmitter;
  emitChange: () => void;
  getStatus: ConnectivityMethod<string, Hasi | undefined>;
  getStatuses: ConnectivityMethod<string[], Hasi | Hasi[]>;
  hasStatus: ConnectivityMethod<string, boolean>;
  init: () => void;
  isClosed: ConnectivityMethod<string, boolean>;
  isOpen: ConnectivityMethod<string, boolean>;
  isReady: ConnectivityMethod<string, boolean>;
  isServiceOnline: ConnectivityMethod<HEALTH_ENDPOINTS, boolean>;
  isSlow: ConnectivityMethod<string, boolean>;
  listenToStatusChange: ConnectivityMethodCallback<string, (value: Hasi[]) => void, () => void>;
  listenToStatusesChange: ConnectivityMethod<(value: Hasi[]) => void, () => void>;
  setStatus: ConnectivityMethodCallback<string, CONNECTIVITY_STATUSES, undefined | string | HasiStatus | void>;
  setStatuses: ConnectivityMethod<Hasi | Hasi[], void>;
};
